import { render, staticRenderFns } from "./ArchivarCandidato.vue?vue&type=template&id=a2ce9a7a"
import script from "./ArchivarCandidato.vue?vue&type=script&lang=js"
export * from "./ArchivarCandidato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports